const ParallaxSection = ({ data }: any) => {
  return (
    <section className="cta__area" style={{ padding: "80px 0" }}>
      <div
        className="cta__bg"
        // data-background={"/assets/img/bg/cta_bg.jpg"}
        style={{backgroundImage:`url("assets/img/bg/h4_video_bg.jpg")`}}
      ></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="cta__content">
              <h2 className="title" style={{ textTransform: "none" }}>
                {data || "Connecting Talent with Opportunities"}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParallaxSection;
